import { render, staticRenderFns } from "./CloudAccountSetupGuide.vue?vue&type=template&id=06bcf9c6&scoped=true"
import script from "./CloudAccountSetupGuide.vue?vue&type=script&lang=js"
export * from "./CloudAccountSetupGuide.vue?vue&type=script&lang=js"
import style0 from "./CloudAccountSetupGuide.vue?vue&type=style&index=0&id=06bcf9c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bcf9c6",
  null
  
)

export default component.exports